import { TypeValidationVas } from '../../interfaces/TypeValidationVas/TypeValidationVas'
import { TypeValidationVasAction } from '../actions/TypeValidationVasAction'
import { typeValidationVasActionTypes } from '../types/typeValidationVasActionTypes'

export interface TypeValidationVasState {
  typeValidationVasState: {
    typeValidationVas?: TypeValidationVas[]
    error?: string | undefined
  }
}

const initialState: TypeValidationVasState = {
  typeValidationVasState: { typeValidationVas: [], error: '' }
}

export const typeValidationVasReducer = (
  state: TypeValidationVasState = initialState,
  action: TypeValidationVasAction
): TypeValidationVasState => {
  if (
    action.type === typeValidationVasActionTypes.GET_TYPE_VALIDATION_VAS_EXITO
  ) {
    return {
      ...state,
      typeValidationVasState: {
        typeValidationVas: action.typeValidationVas,
        error: action.error
      }
    }
  }

  return state
}
